import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { IdentityContext } from "@react-beets/identity";
import LogoutIcon from "@mui/icons-material/Logout";
import { ApplicationPath } from "../../../constants";

function LogoutButton() {
  const history = useHistory();
  const { identity } = useContext(IdentityContext);

  if (!identity || !identity.profile) return null;

  const onClick = () => {
    history.push(ApplicationPath.LogOut);
  };

  return (
    <ListItem onClick={onClick} button={true}>
      <ListItemIcon>
        <LogoutIcon />
      </ListItemIcon>
      <ListItemText primary="Logout" />
    </ListItem>
  );
}

export default LogoutButton;
